import { render, staticRenderFns } from "./manage_stock.vue?vue&type=template&id=49f1043a&scoped=true"
import script from "./manage_stock.vue?vue&type=script&lang=js"
export * from "./manage_stock.vue?vue&type=script&lang=js"
import style0 from "./manage_stock.vue?vue&type=style&index=0&id=49f1043a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1043a",
  null
  
)

export default component.exports